const GMT_MINUS_3_OFFSET_MS = 3 * 60 * 60 * 1000;
const SWITCH_TIME_MINUTES = 19 * 60 + 45;

const WEEKDAYS_PT_BR = [
  "Domingo",
  "Segunda",
  "Terça",
  "Quarta",
  "Quinta",
  "Sexta",
  "Sábado",
] as const;

// index 0 = Domingo ... 6 = Sábado
const GROUP_URLS_BY_DAY = [
  "https://chat.whatsapp.com/LDKeRjl8yizLlH3faJn497", // Domingo
  "https://chat.whatsapp.com/Ckqsj8iT6d3K079u9Yx2eL", // Segunda
  "https://chat.whatsapp.com/HWLUvu9YD8E9sZ8Gp3WSgE", // Terça
  "https://chat.whatsapp.com/E7f2Gf1ZPfj2AtSUYDh6vg", // Quarta
  "https://chat.whatsapp.com/HxNLxPHd1ocLYWOQypEtcE?s=cl&p=i&mlu=4&ilr=4", // Quinta
  "https://chat.whatsapp.com/JOlmL3gUvfIHfUcE15Imsh", // Sexta
  "https://chat.whatsapp.com/Cfvghfgo7HnDdJXuCHX3uo", // Sábado
] as const;

function extractGroupCode(url: string) {
  const match = url.match(/\/([^/?]+)(?:[?#]|$)/);
  return match ? match[1] : url;
}

function getGmtMinus3Date(now: Date) {
  return new Date(now.getTime() - GMT_MINUS_3_OFFSET_MS);
}

export function getCurrentWhatsAppGroupUrl(now = new Date()) {
  const d = getGmtMinus3Date(now);
  const currentDay = d.getUTCDay();
  const currentMinutes = d.getUTCHours() * 60 + d.getUTCMinutes();
  const targetDay =
    currentMinutes >= SWITCH_TIME_MINUTES ? (currentDay + 1) % 7 : currentDay;
  return GROUP_URLS_BY_DAY[targetDay];
}

export function getCurrentWhatsAppGroupCode(now = new Date()) {
  return extractGroupCode(getCurrentWhatsAppGroupUrl(now));
}

export function getCurrentEventLabel(now = new Date()) {
  const d = getGmtMinus3Date(now);
  const currentMinutes = d.getUTCHours() * 60 + d.getUTCMinutes();
  if (currentMinutes >= SWITCH_TIME_MINUTES) {
    d.setUTCDate(d.getUTCDate() + 1);
  }
  const weekday = WEEKDAYS_PT_BR[d.getUTCDay()];
  const day = String(d.getUTCDate()).padStart(2, "0");
  const month = String(d.getUTCMonth() + 1).padStart(2, "0");
  return `${weekday} • ${day}/${month} às 20h`;
}

export function getMillisecondsUntilNextEventDateChange(now = new Date()) {
  const d = getGmtMinus3Date(now);
  const next = new Date(d);
  next.setUTCHours(19, 45, 0, 0);
  if (d.getTime() >= next.getTime()) {
    next.setUTCDate(next.getUTCDate() + 1);
  }
  return next.getTime() - d.getTime();
}

// Data/hora (ISO real, UTC) da próxima aula — sempre 20h em GMT-3.
export function getNextClassDateIso(now = new Date()) {
  const d = getGmtMinus3Date(now);
  const target = new Date(d);
  target.setUTCHours(20, 0, 0, 0);
  const currentMinutes = d.getUTCHours() * 60 + d.getUTCMinutes();
  if (currentMinutes >= SWITCH_TIME_MINUTES) {
    target.setUTCDate(target.getUTCDate() + 1);
  }
  // converte de volta para tempo real (UTC)
  return new Date(target.getTime() + GMT_MINUS_3_OFFSET_MS).toISOString();
}

